import { render, staticRenderFns } from "./Parceria_SindirepaQueimados.vue?vue&type=template&id=e9a36628"
import script from "./Parceria_SindirepaQueimados.vue?vue&type=script&lang=js"
export * from "./Parceria_SindirepaQueimados.vue?vue&type=script&lang=js"
import style0 from "./Parceria_SindirepaQueimados.vue?vue&type=style&index=0&id=e9a36628&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports